<template>
  <div class="events">
    <!-- Controls -->
    <div class="bg-black p-2 rounded" style="height: 680px;">
        <div class="row">
            <div class="col-md-2">
                <input type="text" class="btn bg-black text-white fw-light fs-2 w-100 mt-3" :class="{'fa-fade': gettingEvents }" style="letter-spacing: 5px; cursor: default; opacity: 1;" value="Events" disabled>
            </div>
            <div class="col-md-10">
                <div class="input-group flex-nowrap">
                    <!-- Start -->
                    <div class="input-group flex-nowrap p-1">
                        <button class="btn btn-alchemy-dark bg-gradient w-25 fs-4 rounded" style="cursor: default; border-right: solid 3px black;" :disabled="gettingEvents">
                            <i class="fa-solid fa-xl fa-hourglass-start"></i>
                        </button>
                        <div class="w-75">
                            <input type="date" class="btn btn-alchemy-dark bg-gradient w-100 fs-5" value="2023-03-15" v-model="start.date" :disabled="gettingEvents">
                            <input type="time" class="btn btn-alchemy-dark bg-gradient w-100 fs-5 mt-1" value="00:00" v-model="start.time" :disabled="gettingEvents">
                        </div>
                    </div>
                    <!-- End -->
                    <div class="input-group flex-nowrap p-1">
                        <button class="btn btn-alchemy-dark bg-gradient w-25 fs-4 rounded" style="cursor: pointer; border-right: solid 3px black;" @click="setNow('end')" :disabled="gettingEvents">
                            <i class="fa-solid fa-xl fa-hourglass-end"></i>
                        </button>
                        <div class="w-75">
                            <input type="date" class="btn btn-alchemy-dark bg-gradient w-100 fs-5" value="2023-03-15" v-model="end.date" :disabled="gettingEvents">
                            <input type="time" class="btn btn-alchemy-dark bg-gradient w-100 fs-5 mt-1" value="00:00" v-model="end.time" :disabled="gettingEvents">
                        </div>
                    </div>
                    <!-- Search -->
                    <button class="btn btn-alchemy bg-gradient rounded fs-4 mt-1" style="height: 92px; width: 20%;" @click="getEvents">
                        <i class="fa-solid fa-xl fa-magnifying-glass" :class="{'fa-beat': gettingEvents}"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-12" align="center">
                <div v-show="eventsReady && viewMode=='timeline'" class="w-100" style="border-top: solid 2px rgb(115, 70, 205);" >
                    <div class="input-group flex-nowrap mt-1">
                        <div style="width: 93%;"></div>
                        <button v-if="eventsReady" class="btn bg-alchemy-dark bg-gradient rounded fs-4" style="width: 7%;" @click="toggleView">
                            <i class="fa-solid fa-xl" :class="{'fa-list': viewMode=='timeline', 'fa-timeline': viewMode=='list'}"></i>
                        </button>
                    </div>
                    <Timeline class="" style="margin-top: -45px;" timelineHeight="550" :events="timeline" ref="eventsTimeline"></Timeline>
                </div>
                <div v-if="eventsReady && viewMode=='list'" class="w-100" style="border-top: solid 2px rgb(115, 70, 205); height: 510px;" >
                    <div class="input-group flex-nowrap border-bottom-alchemy p-1">
                        <input type="text" class="btn bg-alchemy-dark fs-5 me-1" style="width: 70%; cursor: text;" v-model="filter" :placeholder="`Filter by ${filtersAlias[filterBy]}`">
                        <select class="btn fs-5 bg-alchemy-dark bg-gradient me-1" style="width: 20%;" v-model="filterBy">
                            <option value="parent_name">Device Name</option>
                            <option value="name">Event Name</option>
                            <option value="type">Event Type</option>
                            <option value="description">Event Description</option>
                            <option value="severity">Severity</option>
                            <option value="registration">Timestamp</option>
                        </select>
                        <!-- View -->
                        <button v-if="eventsReady" class="btn bg-alchemy-dark bg-gradient rounded fs-5" style="width: 10%;" @click="toggleView">
                            <i class="fa-solid fa-xl" :class="{'fa-list': viewMode=='timeline', 'fa-timeline': viewMode=='list'}"></i>
                        </button>
                    </div>
                    <div class="mt-1" style="">
                        <div class="bg-black rounded">
                            <div class="mt-1" id="markers_notificators">
                                <div id="markerTargetsTable">   
                                    <div class="tableFixHead" style="height: 500px;">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th class="fw-light bg-alchemy text-white fs-5" title="Event Enumeration">
                                                        <i class="fa-solid fa-lg fa-arrow-up-1-9"></i>
                                                    </th>
                                                    <th class="fw-light bg-alchemy text-white fs-5"  title="Event Type">
                                                        <i class="fa-solid fa-lg fa-cube"></i>
                                                    </th>
                                                    <th class="fw-light bg-alchemy text-white fs-5 text-start" title="Device">
                                                        <i class="fa-solid fa-lg fa-desktop"></i>
                                                    </th>
                                                    <th class="fw-light bg-alchemy text-white fs-5 text-start" title="Name">
                                                        Name
                                                    </th>
                                                    <th class="fw-light bg-alchemy text-white fs-5 text-start" title="Description">
                                                        Description
                                                    </th>
                                                    <th class="fw-light bg-alchemy text-white fs-5" title="Timestamp">
                                                        <i class="fa-solid fa-lg fa-clock"></i>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(_event, _evi) in filteredEvents" v-bind:key="_evi+1"> <!-- Content Row -->
                                                    <td class="text-center bg-transparent" style="border-bottom: solid 1px rgb(50,50,50); width: 5%;">
                                                        <button class="btn bg-gradient fw-light fs-6 border-0 rounded text-center" :class="{'btn-alchemy-success': _event.severity == 'CLEAR', 'btn-alchemy-warning': _event.severity == 'MINOR', 'btn-alchemy-danger': _event.severity == 'MAJOR', 'btn-danger text-white': _event.severity == 'CRITICAL' }" :title="`Severity: ${_event.severity}`">
                                                            {{_evi+1}}
                                                        </button>
                                                    </td>
                                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                        <button class="btn btn-alchemy-dark bg-gradient fw-light fs-6" :title="`Alert Type : ${_event.type}`" :class="{'btn-alchemy-success': _event.severity == 'CLEAR', 'btn-alchemy-warning': _event.severity == 'MINOR', 'btn-alchemy-danger': _event.severity == 'MAJOR', 'btn-danger text-white': _event.severity == 'CRITICAL' }">
                                                            <i class="fa-solid fa-lg" :class="{ 'fa-heart-pulse':  _event.type=='status',
                                                                                                'fa-microchip':  _event.type=='cpu',
                                                                                                'fa-memory':    _event.type=='memory',
                                                                                                'fa-link':       _event.type=='ping',
                                                                                                'fa-gear':      _event.type=='process',
                                                                                                'fa-clock':     _event.type=='process-timeout',
                                                                                                'fa-ethernet':  _event.type=='target-interface',
                                                                                                'fa-gears':     _event.type=='target-os-service',
                                                                                                'fa-beat-fade': _event.severity != 'CLEAR' }"></i>
                                            
                                                        </button>
                                                    </td>
                                                    <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 20%;">
                                                        <input class="fw-bold fs-6 border-0 rounded text-white text-start w-100" :value="_event.parent_name" style="cursor: default; background-color: transparent; opacity: 1;" disabled>
                                                    </td>
                                                    <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 25%;">
                                                        <input class="fs-6 border-0 rounded text-white text-start w-100" :value="_event.name" style="cursor: default; background-color: transparent;" readonly>
                                                    </td>
                                                    <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30%;">
                                                        <input class="fw-light fs-6 border-0 rounded text-white text-start w-100" :value="_event.description" style="cursor: default; background-color: transparent;" readonly>
                                                    </td>
                                                    <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 15%;">
                                                        <input class="fw-light fs-6 border-0 rounded text-white text-center w-100" :value="_event.registration" style="cursor: default; background-color: transparent;" readonly>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="!eventsReady">
                    <div class="bg-black p-2 rounded text-white fs-3" style="height: 560px;">
                        <div style="margin-top: 17%;">
                            <i class="fa-solid fa-xl fa-calendar-days fa-fade" :class="{'fa-beat': gettingEvents}"></i>
                            <p v-if="!gettingEvents" class="text-white fw-ligh fa-fade">Search for events.</p>
                            <p v-if="gettingEvents" class="text-white fw-ligh fa-fade">Searching events</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// Import the vue components

/* 

<div class="col-md-6">
    <div class="bg-dark rounded p-1" style="height: 580px;">
        <p class="text-white fw-light ">Events Chart</p>
        <div class="bg-black p-1 rounded">
            <LineChart :chartData="eventsChartData"></LineChart>
        </div>
    </div>
</div>

*/


// Import the component with the line below.
import Timeline from '@/components/apps-components/alchemy/subs/Timeline.vue'
import LineChart from '@/components/apps-components/alchemy/subs/charts/LineChart.vue'

import axios from "axios";

export default {
  name: 'Events',
  components: {
    Timeline,
    LineChart
  },
  data(){
    return {
        // General for the requests.
        site: null,
        stage: null,
        // Events
        events: [],
        timeline: {},
        gettingEvents: false,
        eventsReady: false,
        eventsMessage: "Waiting for execution...",
        period: "day",
        now: "2000-01-01 00:04:00",
        start: { date: null, time: '00:00' },
        end: { date: null, time: null },
        filterBy: 'name',
        filter: '',
        filtersAlias:{
          parent_name: 'Device Name',
          name: 'Event Name',
          type: 'Event Type',
          description: 'Event Description',
          severity: 'Severity',
          registration: 'Timestamp'  
        },
        viewMode: 'timeline',


        // Devices
        devices: [],
        device: {uid: null, name: "Name", ip: "0.0.0.0", role: 'role', os: 'os'},
        gettingDevices: false,
        devices_filter: "all",
        selected_device: "invalid",
        selected_device_disable: true,
        bases: {
            // Device Roles
            role: require("@/assets/img/bases/roles/default_device_role.png"),
            router: require("@/assets/img/bases/roles/base_router.png"),
            switch: require("@/assets/img/bases/roles/base_switch.png"),
            server: require("@/assets/img/bases/roles/base_server.png"),
            firewall: require("@/assets/img/bases/roles/base_firewall.png"),
            // Device OS's
            os: require("@/assets/img/bases/os/default_device_os.png"),
            iosxr: require("@/assets/img/bases/os/base_cisco_xr.png"),
            iosxe: require("@/assets/img/bases/os/base_cisco_xe.png"),
            huawei: require("@/assets/img/bases/os/base_huawei.png"),
            ubuntu: require("@/assets/img/bases/os/base_ubuntu.png")
        },

        // Chart
        eventsChartData: {
            labels: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July'
            ],
            datasets: [
                {
                    label: 'Connectivity',
                    backgroundColor: 'White',
                    borderColor: "White",
                    borderWidth: 2,
                    tension: 0.2,
                    data: [0, 100, 100, 100, 100, 100, 100]
                },
                {
                    label: 'Ping',
                    backgroundColor: 'Blue',
                    borderColor: "Blue",
                    borderWidth: 2,
                    tension: 0.2,
                    data: [0, 80, 80, 100, 0, 0, 0]
                },
                {
                    label: 'CPU',
                    backgroundColor: 'Green',
                    borderColor: "Green",
                    borderWidth: 2,
                    tension: 0.2,
                    data: [0, 80, 80, 100, 50, 20, 10]
                }
            ]
        }
    }
  },
  methods:{
    setNow(_target=null){
        this.now = new Date();
        //var now_to_min = this.now
        //const newDate = this.subtractHours(now_to_min, 2);

        // Day
        if (this.now.getDate() < 10){
            var day = '0' + String(this.now.getDate())
        }
        else{
            var day = this.now.getDate()
        }
        // Month
        if (this.now.getMonth()+1 < 10){
            var month = '0' + String(this.now.getMonth()+1)
        }
        else{
            var month = this.now.getMonth()+1
        }


        this.today = `${this.now.getFullYear()}-${month}-${day}`

        if (this.now.getHours() < 10){
            var h = '0' + String(this.now.getHours())
        }
        else{
            var h = this.now.getHours()
        }

        if (this.now.getMinutes() < 10){
            var m = '0' + String(this.now.getMinutes())
        }
        else{
            var m = this.now.getMinutes()
        }
        this.time = `${h}:${m}`
        // Device
        if (_target == null){
            this.start.date = this.today
            this.end.date = this.today
            this.end.time = this.time
        }
        else if (_target == 'end'){
            this.end.date = this.today
            this.end.time = this.time
        }
    },
    toggleView(){
        if(this.viewMode == 'list'){
            this.viewMode = 'timeline'
        }
        else if(this.viewMode == 'timeline'){
            this.viewMode = 'list'
        }
    }, 
    getDevices(){
        this.clear()
        this.eventsMessage = "Getting devices."
        this.gettingDevices = true
        this.devices = []
        const params = {filter: this.devices_filter}
        const dest = this.site + '/alchemy/events/getDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                this.devices = rx.data.data.devices
                this.gettingDevices = false
            })
            .catch(error => {
                this.eventsMessage = this.processErrorMessage(error)
                this.gettingDevices = false
            });
    },
    setDevice(){
        if (this.selected_device == "invalid"){  this.clear(); return }
        this.device = this.selected_device
        this.selected_device_disable = false
    },
    clear(){
        this.selected_device_disable = true
        this.device = {uid: null, name: "Name", ip: "0.0.0.0", role: 'role', os: 'os'}
        this.selected_device = "invalid"
        this.period = "day"
        this.eventsMessage = "Waiting for execution..."
        this.eventsReady = false
        this.gettingEvents = false
    },
    // Events
    getEvents(){
        this.gettingEvents = true
        this.eventsReady = false
        this.eventsMessage = "Retrieving events..."
        this.events = []
        this.timeline = {}
        this.$refs['eventsTimeline'].resetVisor()
        const params = { 
            start: `${this.start.date} ${this.start.time}:00`,
            end: `${this.end.date} ${this.end.time}:00` 
        }
        const dest = this.site + '/alchemy/events/getEvents'
        axios
            .get(dest, {params})
            .then(rx => {
                this.events = rx.data.data.events.data
                this.timeline = rx.data.data.events.timeline
                this.gettingEvents = false
                this.eventsReady = true
            })
            .catch(error => {
                this.eventsMessage = this.processErrorMessage(error)
                this.gettingEvents = false
                this.eventsReady = false
            });
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },
    // Miscelaneous
    capitalize(_string){
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    getImage(base){
        return this.bases[base]
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  mounted: function(){
    //this.getDevices()
    this.setNow()
  },
  created: function(){
    //this.appclient = localStorage.getItem('vrfaware_client')
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
  },
  computed: {
    filteredEvents(){
        if (this.filter == ''){
            return this.events
        }
        this.filter = this.filter.toLowerCase()
        return this.events.filter( event => String(event[this.filterBy]).toLowerCase().includes( this.filter ) );
    }
  }
}
</script>

<style scoped>


  .btn-alchemy{
    background-color: rgb(115, 70, 205);
    color: White;
    transition-duration: 0.6s;
  }
  .btn-alchemy:hover{
    background-color: rgb(0, 0, 26);
    color: rgb(115, 70, 205);
  }

  .btn-alchemy-dark{
    background-color: rgb(0,0,26);
    color: White;
    transition-duration: 0.6s;
  }
  .btn-alchemy-dark:hover{
    background-color: rgb(115, 70, 205);
    color: rgb(0,0,26);
  }

  .btn-alchemy-success{
    background-color: rgb(115, 70, 205);
    color: White;
  }
  .btn-alchemy-danger{
    background-color: rgb(161, 91, 0);
    color: White;
  }
  .btn-alchemy-warning{
    background-color: rgb(187, 255, 0);
    color: rgb(0, 0, 0);
  }
  .btn-alchemy-off{
    background-color: rgb(0, 3, 25);
    color: rgb(161, 91, 0);
  }

  .bg-alchemy{
    background-color: rgb(0, 0, 26);
    color: White
  }
  .bg-alchemy-success{
    background-color: rgb(115, 70, 205);
    color: White;
  }
  .bg-alchemy-danger{
    background-color: rgb(161, 91, 0);
    color: White;
  }
  .bg-alchemy-dark{
    background-color: rgb(0,0,26);
    color: White;
  }

   .border-alchemy{
    border: solid 2px rgb(115,70,205);
  }
  .border-top-alchemy{
    border-top: solid 2px rgb(115,70,205);
  }
  .border-bottom-alchemy{
    border-bottom: solid 2px rgb(115,70,205);
  }
  .border-start-alchemy{
    border-left: solid 2px rgb(115,70,205);
  }
  .border-end-alchemy{
    border-right: solid 2px rgb(115,70,205);
  }
   
  .text-alchemy{
    color: rgb(115, 70, 205);
  }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

  .section-button{
    background-color: Black;
    border: solid 2px Black;
    color: White;
  }
  .section-button:hover{
    color: rgb(72,167,238);
    border-bottom: solid 2px rgb(162, 200, 250);
  }


  /* Table with static header */
    .tableFixHead {
        overflow-y: auto;
      }
    .tableFixHead thead th {
        position: sticky;
        top: 0;
        text-align: center;
        z-index: 1;
    }
    table {
        border-collapse: collapse;
        width: 100%;
    }
    th, td {
        padding: 8px 16px;
    }
    th {
        background: #eee;
    }
</style>
